function validateEmail(email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    if (!emailReg.test(email)) {
        return false;
    }
    else {
        return true;
    }
}
jQuery('document').ready(function ($) {
    if ($('.module_9').length > 0) {
        var checkEmailField_1 = function (field) {
            var fieldVal = field.val();
            var isValid = validateEmail(fieldVal);
            var isEmpty = fieldVal == '';
            if (isValid && isEmpty) {
                field.removeClass('valid').addClass('empty');
            }
            else if (!isValid && !isEmpty) {
                field.removeClass('valid').removeClass('empty');
            }
            else {
                field.addClass('valid').removeClass('empty');
            }
        };
        var attachVerification = function (node) {
            node.focusout(function () {
                var field = $(this);
                checkEmailField_1(node);
                var fieldVal = field.val();
                var isValid = validateEmail(fieldVal);
                var isEmpty = fieldVal == '';
                if (isValid && isEmpty) {
                    field.removeClass('valid').addClass('empty');
                }
                else if (!isValid && !isEmpty) {
                    field.removeClass('valid').removeClass('empty');
                }
                else {
                    field.addClass('valid').removeClass('empty');
                }
            });
        };
        var emailFieldForm = $('input#form__email');
        var emailFieldNewsletter = $('input#newsletter__email');
        attachVerification(emailFieldForm);
        attachVerification(emailFieldNewsletter);
        $('.contact__popup_close').on('click', function () {
            var _this = this;
            $('.contact__popup').removeClass('show');
            setTimeout(function () {
                $('.contact__popup').removeClass('display');
                $(_this).parent().removeClass('show');
            }, 300);
        });
    }
});
